export const LOAD_TERMS_LIST = 'load_terms_list';
export const RECEIVE_TERMS_LIST = 'receive_terms_list';
export const GET_FILTERED_LIST = 'get_filtered_list';
export const SET_FILTERED_LIST = 'set_filtered_list';
export const SELECT_TERM = 'select_term';
export const GET_SELECTED_TERM = 'get_selected_term';
export const GET_RELATED_TERMS = 'get_related_terms';

export const SELECT_COUNTRY = 'select_country';
export const SEARCH_FOR_TERM = 'search_for_term';
export const TOGGLE_ICON_VIEW = 'toggle_icon_view';
export const TOGGLE_FAVOURITES_VIEW = 'toggle_favourites_view';

export const LOAD_FAVOURITES = 'load_favourites';
export const ADD_FAVOURITE = 'add_favourite';
export const REMOVE_FAVOURITE = 'remove_favourite';
export const SAVE_FAVOURITES = 'update_favourites';
export const TOGGLE_FAVOURITE = 'toggle_favourite';

//const DATA_URL_START = 'data/cs_';
//const DATA_URL_END = '_v1.0.xml';

const DATA_URL_START = '/data/maths-dictionary-';
const DATA_URL_END = '.json';

import _ from 'lodash';
import axios from 'axios';
import Resources from '../../helpers/resources';

let baseUrl;
const BASE_URL = window._env_.AssetsBaseUrl;
////////////////////////////////////////////////////
// loadTermsList
// Initiate asynchronous request for XML data file.
// Uses axios to handle XHR
// Uses thunk to call dispatch() when file received.
////////////////////////////////////////////////////
export async function loadTermsList(country) {
    baseUrl = BASE_URL;
    let url = baseUrl + DATA_URL_START + country + DATA_URL_END;

    return function (dispatch){
        return axios.get(url)
            .then(
                ( response ) => {
                    dispatch( receiveTermsList(response.request) )
                },
                ( error ) => {
                    console.warn('An error occurred', error);
                }
            )
    }
}

////////////////////////////////////////////////////
// receiveTermsList
// called asynchronously from loadTermsList
// Maps dictionary elements to an array which is loaded to
// the redux store.
////////////////////////////////////////////////////
export function receiveTermsList(doc){
    //const xmlDoc = doc.responseXML;
    let dictionaryDataObject = JSON.parse(doc.responseText);
    let dict = dictionaryDataObject.Dictionary.map(item => (
      { termName: item.term,
        file_resource: item.file_resource,
        categories: item.categories,
        related_terms: item.related_terms,
        age_group: item.age_group,
        desc: item.desc,
        level_group: item.level_group,
        sound: item.sound,
        levels: item.levels
      }
    ));

   /* for (dictionaryItem in dictionaryDataObject.Dictionary) {
        dict.push(dictionaryItem);
    }*/

    //let x = xmlDoc.getElementsByTagName("term_record");

/*    for (let i = 0; i < x.length; i++) {

        let termName = x[i].getAttribute('term');
        let fileResource = x[i].getAttribute('file_resource');
        let categories = x[i].getAttribute('categories');
        let relatedTerms = x[i].getAttribute('related_terms');
        let ageGroup = x[i].getAttribute('age_group');
        let desc = x[i].getAttribute('desc');
        let levelGroup = x[i].getAttribute('level_group');
        let sound = x[i].getAttribute('sound');
        let levels = x[i].getAttribute('levels');

        let term = {
            "termName": termName,
            "file_resource": fileResource,
            "categories": categories,
            "related_terms": relatedTerms,
            "age_group": ageGroup,
            "desc": desc,
            "levelGroup": levelGroup,
            "sound": sound,
            "levels": levels
        }
        dict.push(term);
    }*/

    return {
        type: RECEIVE_TERMS_LIST,
        payload: dict,
        url: baseUrl
    };
}

export function getFilteredList(level){
    return {
        type: GET_FILTERED_LIST,
        payload: level
    }
}

export function setFilteredList(list){
    return {
        type: SET_FILTERED_LIST,
        payload: list
    }
}

export function selectTerm(termName, level) {
    return {
        type: SELECT_TERM,
        payload: {
          termName,
          level
        }
    }
}

export function getSelectedTerm() {
    return {
        type: GET_SELECTED_TERM
    }
}

////////////////////////////////////////////////////
// getRelatedTerms
// builds an array of related terms, matched from
// links to other terms stored in source XML
////////////////////////////////////////////////////
export function getRelatedTerms(term, termsList){
    let relatedTermsList = [];
    if (term) {
        const namesList = term.related_terms.split(',');
    
        for (let i = 0; i < termsList.length; i++){
            for (let j = 0; j < namesList.length; j++){
                if (termsList[i].termName === namesList[j].trim() && termsList[i].age_group === term.age_group){
                    relatedTermsList.push(termsList[i]);
                }
            }
        }
    }
    
    return {
        type: GET_RELATED_TERMS,
        payload: relatedTermsList
    }
}

export function selectCountry(country) {
    return {
        type: SELECT_COUNTRY,
        payload: country
    }
}

export function searchForTerm(searchTerm) {
    return {
        type: SEARCH_FOR_TERM,
        payload: searchTerm
    }
}

export function toggleIconView() {
    return {
        type: TOGGLE_ICON_VIEW
    }
}

export function toggleFavouritesView(isFavouritesView) {
    return {
        type: TOGGLE_FAVOURITES_VIEW,
        payload: {
            isFavouritesView
        }
    }
}

////////////////////////////////////////////////////
// Favourites
// Uses localStorage to persist and retrieve list
// of favourite terms.
////////////////////////////////////////////////////
export function loadFavourites() {
    // Init Favourites list from local storage to state
    let favouritesList = [];
    const tempList = JSON.parse(localStorage.getItem('favourites'));
    _.forEach(tempList, (term) => {
        favouritesList.push(term);
    });
    return {
        type: LOAD_FAVOURITES,
        payload: favouritesList
    }
}

export function addFavourite(term) {
    return {
        type: ADD_FAVOURITE,
        payload: term
    }
}

export function removeFavourite(term) {
    return {
        type: REMOVE_FAVOURITE,
        payload: term
    }
}

export function saveFavourites(favouritesList) {
    localStorage.setItem('favourites', JSON.stringify(favouritesList));
    return {
        type: SAVE_FAVOURITES
    }
}

export function toggleFavourite(term){
    return {
        type: TOGGLE_FAVOURITE,
        payload: term
    }
}
